import { render, staticRenderFns } from "./bannerCommon.vue?vue&type=template&id=ecd6f11e&scoped=true&"
import script from "./bannerCommon.vue?vue&type=script&lang=js&"
export * from "./bannerCommon.vue?vue&type=script&lang=js&"
import style0 from "./bannerCommon.vue?vue&type=style&index=0&id=ecd6f11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd6f11e",
  null
  
)

export default component.exports